import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, BODY } from "../shared";
import mauerSitzendImg from "@/assets/img/luisa-mauer-sitzend.jpeg";

const lines = [
  "Hör auf, nach den Regeln zu spielen.",
  "Hör auf, gegen sie anzukämpfen.",
  "Mach einfach Dein eigenes Spiel.",
];

export default function EigenesSpielSection() {
  return (
    <Section testId="eigenes-spiel-section" className="py-28 md:py-40">
      <div className="grid gap-14 md:grid-cols-12 md:items-center">
        <div className="md:col-span-7">
          {lines.map((line, i) => (
            <Reveal key={line} delay={i * 0.1}>
              <p
                className={`font-heading font-700 uppercase leading-[1.05] tracking-tight text-[clamp(1.6rem,4vw,2.9rem)] ${i === 2 ? "text-cognac-2" : "text-espresso"}`}
                style={{ fontWeight: 700 }}
              >
                {line}
              </p>
            </Reveal>
          ))}
          <Reveal delay={0.34}>
            <p className={`${BODY} mt-10 max-w-xl`}>
              Vielleicht gründest Du Dein eigenes Unternehmen. Vielleicht tust Du Dich mit anderen zusammen. Oder gehst in ein Unternehmen, das schon jetzt anders spielt – denn ja: die gibt es bereits.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <p className={`${BODY} mt-6 max-w-xl font-600 text-espresso`} style={{ fontWeight: 600 }}>
              Willkommen zu <strong style={{ fontWeight: 700 }}>Unverschämt Erfolgreich</strong>.
            </p>
          </Reveal>
          <Reveal delay={0.44}>
            <p className={`${BODY} mt-4 max-w-xl text-espresso`}>
              Hier geht es nicht darum, das alte Spiel einfach nur besser zu spielen. Sondern Deinen Job nach Deinen Regeln zu kreieren.
            </p>
          </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 -z-10 bg-gold" />
              <img src={mauerSitzendImg} alt="Luisa Bergholz sitzend auf einer Mauer" width="1202" height="1749" className="w-full object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
